import { axios } from '@/services/axios';

const getPermissionsSetById = async ({ id }) => {
    const res = await axios.get(`/permissionset/${id}`);
    return res.data;
};

export default getPermissionsSetById;
